import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { Header } from './header';
import { MobileSidebar } from './mobile-sidebar';
import { SubscriptionAlert } from '@/components/billing';
import { useSubscriptionStore } from '@/stores/subscription-store';

// Polling interval: 5 minutes
const POLLING_INTERVAL = 5 * 60 * 1000;

export function AppLayout() {
  const fetchStatus = useSubscriptionStore((state) => state.fetchStatus);
  const fetchLimits = useSubscriptionStore((state) => state.fetchLimits);

  // Fetch subscription status and limits on mount and poll periodically
  useEffect(() => {
    // Fetch immediately
    fetchStatus();
    fetchLimits();

    // Set up polling for status (limits don't need frequent polling)
    const interval = setInterval(fetchStatus, POLLING_INTERVAL);

    return () => clearInterval(interval);
  }, [fetchStatus, fetchLimits]);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <MobileSidebar />
      <div className="flex min-w-0 flex-1 flex-col md:ml-[248px]">
        <Header />
        <main className="scrollbar-thin flex-1 px-4 py-5 sm:px-6 lg:px-8 lg:py-7">
          <SubscriptionAlert className="mb-4" dismissible />
          <div className="page-enter mx-auto w-full max-w-[1480px]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
